<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [link]="showProjectName && activity.Project ? ['/projects', activity.Project.Id] : null">
    <i scActivityIcon class="fa-sharp fa-solid fa-briefcase"></i>
    {{ texts.projectCreated[language] }}
</sc-activity-list-item>
